import { render, staticRenderFns } from "./CredentialFooter.vue?vue&type=template&id=175424d4&"
import script from "./CredentialFooter.vue?vue&type=script&lang=ts&"
export * from "./CredentialFooter.vue?vue&type=script&lang=ts&"
import style0 from "./CredentialFooter.vue?vue&type=style&index=0&id=175424d4&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('175424d4')) {
      api.createRecord('175424d4', component.options)
    } else {
      api.reload('175424d4', component.options)
    }
    module.hot.accept("./CredentialFooter.vue?vue&type=template&id=175424d4&", function () {
      api.rerender('175424d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/layout/CredentialFooter.vue"
export default component.exports